import { useQuery } from "react-query";
import { agent } from "~/util/agent";

const useOrgIdViaEmail = (email?: string, enabled = true) =>
  useQuery(
    ["org-id-via-email"],
    async () =>
      agent(`public/orgid-via-email?email=${encodeURIComponent(email)}`, {
        headers: {
          "Content-Type": "text/plain",
        },
      }).text(),
    {
      enabled: !!email && enabled,
    }
  );

export { useOrgIdViaEmail };
